import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2 4v16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 8h18a2 2 0 0 1 2 2v10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 17h20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 8v9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bed";
const Bed = memo(themed(Icon));
export {
  Bed
};
//# sourceMappingURL=bed.js.map
